<template>
  <v-flex class="sfh-login-header text-xs-center pa-1">
    <!-- For Sticky top --->
    <v-layout row align-center justify-space-between>
      <div class="xs8 text-xs-left d-flex align-center" >
        <img @click.stop="$store.commit('toggleLeftDrawer', true)"
             height="50"
             width="50"
             :src="appIcon"
             style="cursor:pointer;"
             alt="sfh" />

        <h2  class="white--text font-weight-bold float-left mt-2 line-height-1"
             style="text-align: left;"><slot></slot></h2>
      </div>
      <v-flex xs4 text-xs-right>

        <v-btn fab color="transparent" @click.stop="$store.commit('toggleRightDrawer', true)"
               class="elevation-2 mr-0" style="width:42px;height:42px;">
          <div class="user-avatar elevation-10"
               :style="{ backgroundImage: 'url(' + $store.getters['user/avatar'] + ')',height:'40px',width:'40px' }"></div>
        </v-btn>
        <v-toolbar-side-icon class="ml-0" dark  @click.stop="$store.commit('toggleRightDrawer', true)"
        ></v-toolbar-side-icon>
      </v-flex>
    </v-layout>

    <navigation-menu></navigation-menu>
    <v-navigation-drawer
      temporary
      v-model="leftDrawer"
      app
      class="secondary darken-4"
    >
      <v-layout row>
        <v-flex style="padding-top: env(safe-area-inset-top)">
          <v-card style="overflow-y: auto; height: calc(100vh - env(safe-area-inset-top) - env(safe-area-inset-bottom))">

            <v-list style="height:25px;" dark dense class="secondary darken-2 pa-0">
              <v-list-tile dark >
                <v-list-tile-content>
                  <v-list-tile-title >
                    <v-flex><strong>{{answered}}</strong> of <strong>{{totalQues}}</strong> questions complete</v-flex>
                  </v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
            <v-list dark dense class="secondary darken-2 pa-0">
              <v-list-tile dark >
                <v-list-tile-content>
                  <v-list-tile-title >
                    <v-flex class="progress progress-lg" style="border-radius:3px">
                      <div id="tenQprogress_1" :style="{width: widthPercent+'%'}" style="border-radius:3px;"
                           class="ten-q-progress progress-bar  progress-bar-default">
                        <span class="text-xs-center font-weight-bold" style="position:relative;">{{widthPercent}}%</span></div>
                    </v-flex>
                  </v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>

            <v-list dark class="secondary darken-4 pa-0">
              <template v-for="(question, index) in questions">
                <v-list-tile
                  light
                  :key="'question_'+index"
                  ripple
                  active-class="primary"
                  :to="`/exam/${groupId}/${deckId}/${index+1}`"
                >
                  <v-list-tile-content>
                    <v-list-tile-title  color="red"> {{question.questionOrder + 1}}. {{ question.name }}</v-list-tile-title>
                  </v-list-tile-content>

                </v-list-tile>
                <v-divider
                  light
                  v-if="index + 1 < questions.length"
                  :key="index"
                ></v-divider>
              </template>
            </v-list>
          </v-card>
        </v-flex>
      </v-layout>
    </v-navigation-drawer>

  </v-flex>

</template>

<script>
  import NavigationMenu from './NavigationMenu'
  import PlainToolbar from './PlainToolbar'

  export default {
    name: 'QuizHeader',
    components: {
      NavigationMenu, PlainToolbar
    },
    data () {
      return {
        appIcon: require('@/assets/logos/' + process.env.APP_ICON),
        groupId: parseInt(this.$route.params.groupId),
        deckId: parseInt(this.$route.params.deckId),
        totalQues: this.$store.getters['exam/getExamQuestionsCount']
      }
    },
    computed: {
      answered: function () {
        return this.totalQues - this.$store.getters['exam/getExamQuestions'].length
      },
      widthPercent: function () {
        return Math.round((this.answered / this.totalQues) * 100)
      },
      step: {
        get: function () {
          return this.$store.getters['exam/getStep']
        },
        set: function (step1) {
          this.$store.commit('exam/setStep', step1)
        }
      },
      leftDrawer: {
        get: function () {
          return this.$store.getters.leftDrawer
        },
        set: function (value) {
          this.$store.commit('toggleLeftDrawer', value)
        }
      },
      questions () {
        return this.$store.getters['exam/getExamQuestions']
      }
    },
    created () {
    },
    methods: {
      // sfhImage () {
      //   return require(`@/assets/images/sfh_icon_with_expansion_indicators.png`)
      // }
      // userImage () {
      //   return require('@/assets/images/avatar180x.jpg')
      // }
    },
    watch: {

    }
  }
</script>
<style scoped>
  .left_nav .v-list__group__header .v-list__group__header__prepend-icon{
    display: none!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/layouts/ExamHeader.vue